import { render, staticRenderFns } from "./Token-custom.vue?vue&type=template&id=7773551c&"
import script from "./Token-custom.vue?vue&type=script&lang=js&"
export * from "./Token-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports